

// 精品项目的后端接口
import request from '@/utils/request'

// 删除文件上传的文件
export const removeProject =(filePath,userName)=>{
    return request.get(
        '/project/removeProject',
        {
            params:{
                filePath:filePath,
                userName:userName
            }
        }
    )
};

// 封面图片-删除
export const removeProjectImage=(filePath,userName)=>{
    return request.get(
        '/project/removeProjectImage',
        {
            params:{
                filePath:filePath,
                userName:userName
            }
        }
    )
};


// 添加项目
export const addProject=(form)=>{
    return request.post(
        '/project/addProject',
        form
    )
};

// 查询所有项目
export const findProject=(form)=>{
    return request.post(
        '/project/queryProject',
        form
    )
};

// 通过项目id获取项目信息
export const queryProjectById=(projectId)=>{
    return request.get(
        '/project/queryProjectById',
        {
            params:{
                projectId:projectId
            }
        }
    )

}

// 项目-兑换码是否可用-兑换成功
export const findConversion=(resData)=>{
    return request.post(
        '/project/findConversion',
        resData
    )
}


// 项目-用户是否已经拥有当前项目
export const findProjectAccessRecords=(recordData)=>{
    return request.post(
        '/project/findProjectAccessRecords',
        recordData
    )
}

// 项目-下载
export const downLoadFile=(projectId)=>{
    return request.get(
        '/project/downLoadFile',
        {
            params:{
                projectId:projectId
            }
        }
    )
}
